import BackButton from '@portal/features/navigation/BackButton'
import { Header } from '@portal/features/navigation/Header'
import EditSubmissionSubtopic from '@portal/features/submissions/EditSubmissionSubtopic'
import { SubtopicTitle } from '@portal/features/titles'
import { createFileRoute, useParams } from '@tanstack/react-router'

const RouteComponent = () => {
  const { surveyId } = useParams({ strict: false })

  return (
    <>
      <Header.Left>
        <BackButton to={`/surveys/${surveyId}/submissions`} />
      </Header.Left>
      <Header.Center>
        <SubtopicTitle />
      </Header.Center>
      <EditSubmissionSubtopic />
    </>
  )
}

export const Route = createFileRoute(
  '/_app/surveys/$surveyId/submissions_/$submissionId/$subtopicId'
)({
  component: RouteComponent,
})
